import { useContext, useEffect } from "react";
import Layout from "../layouts/Layout";
import "./HomePage.css";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { Context } from "../context/Context";
import WirelessKey from "../components/equipments/WirelessKey";
import RoomEquipmentsList from "../components/RoomEquipmentsList";

const WirelessKeyPage = () => {
  const { page, setPage } = useContext(Context);
  useEffect(() => {
    setPage({
      name: "کلید بیسیم",
      slug: "home",
    });
  }, []);
  return (
    <HelmetProvider>
      <Helmet>
        <title>{page.name}</title>
      </Helmet>
        <div className="container-xxl flex-grow-1 container-p-y">
          {/* Layout Demo */}
          <WirelessKey />
          <RoomEquipmentsList />
          {/*/ Layout Demo */}
        </div>
    </HelmetProvider>
  );
};

export default WirelessKeyPage;
